import {
  ADMIN_PREFILL_PRICING_LOADED,
  ADMIN_PREFILL_PRICING_CLEAR,
  ADMIN_PREFILL_ONBOARDING_SUCCESS,
  ADMIN_PREFILL_ONBOARDING_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  pricing: null,
  prefillResult: null,
};

function adminCustomOnboarding(state = initialState, action) {
  switch (action.type) {
    case ADMIN_PREFILL_PRICING_LOADED:
      return { ...state, pricing: action.payload.pricing };
    case ADMIN_PREFILL_PRICING_CLEAR:
      return { ...state, pricing: null };
    case ADMIN_PREFILL_ONBOARDING_SUCCESS:
      return { ...state, prefillResult: action.payload.result };
    case ADMIN_PREFILL_ONBOARDING_CLEAR:
      return { ...state, prefillResult: null };
    default:
      return state;
  }
}

export default adminCustomOnboarding;
